module.exports = __webpack_public_path__ + "img/like-icon5.ca2509d2.svg";